<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-arrow-right-arrow-left"></i></div>
      <div>
        Migration de classe
        <div class="page-title-subheading">Passage des élèves d'une classe à la suivante</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="container">
        <div class="card card-body">
            <div *ngFor="let d of data" class="mb-3">
                <form #addForm="ngForm" (ngSubmit)="setOut(d.id,addForm.value)">

                    <div  class="input-group">
                        <span class="input-group-text w-25">{{d.name}}</span>

                        <ng-select class="form-select" name="classroom_out" [(ngModel)]="d.classroom_out">
                            <ng-option *ngFor="let c of data" [value]="c.id">{{c.name}}</ng-option>
                          </ng-select>
        
                        <button  class="btn btn-outline-secondary" [disabled]="addForm.invalid || loading" type="submit" id="button-addon2">Valider</button>
                      </div>
                    </form>
        
            </div>
           
        </div>
    </div>
